<template>
  <button
    type="button"
    class="facet-option"
    :class="{ 'is-on': selected, 'is-nested': nested }"
    :aria-pressed="String(selected)"
    @click="$emit('toggle')"
  >
    <span class="facet-check"
      ><i v-if="selected" class="mdi mdi-check"></i
    ></span>
    <span class="facet-label">
      <span class="facet-label-text">{{ label }}</span>
      <span v-if="hint" class="facet-hint">{{ hint }}</span>
    </span>
    <span v-if="count !== null" class="facet-count">{{
      formatCount(count)
    }}</span>
  </button>
</template>
<script>
import { formatCount } from "./facetLabels";

// Una opción de filtro: casilla, nombre y cuántos resultados quedan con ella.
export default {
  name: "FacetOption",
  props: {
    label: { type: String, required: true },
    count: { type: Number, default: null },
    selected: { type: Boolean, default: false },
    hint: { type: String, default: null },
    nested: { type: Boolean, default: false }
  },
  methods: { formatCount }
};
</script>
<style lang="scss" scoped>
.facet-option {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  width: 100%;
  padding: 5px 6px;
  border-radius: 5px;
  text-align: left;
  font-size: 13px;
  line-height: 18px;
  color: #111827;

  &:hover {
    background: #f3f4f6;

    .facet-check {
      border-color: #6b7280;
    }
  }

  &:focus-visible {
    outline: 2px solid #2563eb;
    outline-offset: -2px;
  }

  &.is-on .facet-label-text {
    font-weight: 600;
  }

  &.is-nested {
    font-size: 12px;
    padding-left: 22px;
  }
}

.facet-check {
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  margin-top: 1px;
  border: 1px solid #c8cbd0;
  border-radius: 4px;
  background: white;
  color: white;
  font-size: 12px;

  .is-on & {
    background: #111827;
    border-color: #111827;
  }
}

.facet-label {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow-wrap: anywhere;
}

.facet-hint {
  font-size: 11px;
  line-height: 15px;
  color: #6b7280;
}

.facet-count {
  flex: none;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 11px;
  color: #6b7280;
}
</style>
